import { Inject, Injectable, PLATFORM_ID, TemplateRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Locale } from 'assets/data/locale';
import { environment } from 'environments/environment';


const JSONPhone = require("../../../assets/data/phone.json");
import * as moment from 'moment-timezone';
import { Title, Meta } from '@angular/platform-browser';
import {  BehaviorSubject, map, Observable, ReplaySubject } from 'rxjs';
import { LangModel } from 'app/models/lang-model';
import { StockModel } from 'app/models/stock-model';
import { StockPromotionModel } from 'app/models/stock-promotion-model';
import { UserModel } from 'app/models/user';
import { LocationAvailableModel } from 'app/models/location-available-model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { SUPPORTED_LANGUAGES } from '../language/languages';

function browserStorage(): Storage | null {
    if (typeof window === 'undefined') return null;
    try {
        return window.localStorage;
    } catch {
        return null;
    }
}



@Injectable({
  providedIn: 'root'
})
export class AppService {

    private helper = new JwtHelperService();
    public usuario: UserModel = {
        id: 0,
        name: '',
        username: '',
        email: '',
        roles: []
    };
    public static autenticado: boolean = false;
    public static langs: LangModel[] = SUPPORTED_LANGUAGES.map((name, index) => ({ landId: index + 1, name: name.toUpperCase() }));
    private static langDefault: LangModel = AppService.langs[0];
    public static langSel: LangModel = AppService.langDefault;
    // Request-scoped translation selection prevents concurrent SSR renders sharing text state.
    public selectedLanguage: LangModel = AppService.langDefault;
    public cart: any[] = [];
    public locationId?: number;
    public kiosk: string = 'locker';
    public textosTraduccion: any = Locale.locale;
    public phone: any = JSONPhone;
    public servidor: string = environment.urlServer;
    public FORMAT_DATE: string = 'dd-MM-YYYY';
    public FORMAT_DATETIME: string = 'dd-MM-YYYY HH:mm';
    public FORMAT_DATE_SEG: string = 'dd-MM-YYYY HH:mm:ss';
    public static stockLockers:StockModel;
    toasts: any[] = [];
    public static domain:string = '';
    private currentUserSubject$: BehaviorSubject<UserModel> = new BehaviorSubject<UserModel>(null);
    public readonly currentUser$: Observable<UserModel> = this.currentUserSubject$.asObservable();

    private currentStockSubject$: ReplaySubject<StockModel> = new ReplaySubject<StockModel>(1);
    public readonly currentStock$: Observable<StockModel> = this.currentStockSubject$.asObservable();

    private currentPriceSubject$: ReplaySubject<StockPromotionModel> = new ReplaySubject<StockPromotionModel>(1);
    public readonly currentPrice$: Observable<StockPromotionModel> = this.currentPriceSubject$.asObservable();

  constructor(
    @Inject(PLATFORM_ID) platformId: object,
    private titleService: Title,
    public meta: Meta) {
        
      if (isPlatformBrowser(platformId)) {
        AppService.domain = window.location.hostname;
      }
    }

    public get tenantId(): number|null{
        const tenantId = browserStorage()?.getItem('tenant_id');
        return tenantId ? Number(tenantId) : 1;
    }

    public set tenantId(tenantId: number){
        browserStorage()?.setItem('tenant_id', String(tenantId));
    }

    public clearTenantId(){
        browserStorage()?.removeItem('tenant_id');
    }

    public setCurrentUser(currentUser: UserModel): void {
        this.currentUserSubject$.next(currentUser);
    }

    public setCurrentStock(currentStock: StockModel): void {
        this.currentStockSubject$.next(currentStock);
       // this.currentStockSubject$.complete();
    }

    public setCurrentPrice(currentPrice: StockPromotionModel): void {
        this.currentPriceSubject$.next(currentPrice);
        //this.currentPriceSubject$.complete();
    }


    public setToken(token: string){
        browserStorage()?.setItem('token', token);
    }
    public getToken(){
        return browserStorage()?.getItem('token') ?? null;
    }
    
    saveOriginalToken() {
        const current = this.getToken();
        if (current) {
            browserStorage()?.setItem('token-orign', current);
        }
    }

    restoreOriginalToken() {
        const original = browserStorage()?.getItem('token-orign');
        if (original) {
            this.setToken(original);
            browserStorage()?.removeItem('token-orign');
        }
    }

    isTokenExpired(token?: string): boolean {
        token ??= this.getToken() ?? undefined;
        if (!token) return false;
        return this.helper.isTokenExpired(token);
    }
    isImpersonating():boolean{
        return !!browserStorage()?.getItem('token-orign');
    }
    
    public static getToken() {
        return browserStorage()?.getItem('token') ?? null;
    }
    public static isToken() {
        return !!browserStorage()?.getItem('token');
    }
    public static clearToken(){
        AppService.autenticado = false;
        browserStorage()?.clear();
    }
    public set clientSelected(clientSelected: LocationAvailableModel){
        if(clientSelected != null){
            browserStorage()?.setItem('clientSelected', JSON.stringify(clientSelected));
        }
    }
    public get clientSelected(): LocationAvailableModel{
       try{
        const selected = browserStorage()?.getItem('clientSelected');
        return selected ? JSON.parse(selected) : {} as LocationAvailableModel;
       }catch(e){
            console.warn(e);
            return {} as LocationAvailableModel;
       }
    }

    public clearlocation(){
        browserStorage()?.removeItem('clientSelected');
    }

    public autenticado(){
        return AppService.autenticado;
    }
    
    isAdmin(): boolean{
        return AppService.autenticado && this.usuario.roles.find(i => i == 'ROLE_ADMIN') != null;
    }

    public hasRoles(allowedRoles: string[]): boolean {
        const user = this.currentUserSubject$.getValue();
        return !!user && !!user.roles && user.roles.some(rol => allowedRoles.includes(rol));
    }

    getTraduccion(value: string, params?: Record<string, any>): string {
        if (!value) {
            return value;
        }

        const translatedValue = this.getStaticTraduccion(value);

        return this.resolveTranslationParams(translatedValue, params);
    }

     public getLiteralTraduccion(value: any, property: string): string {
        if (!value?.literals || !property) {
            return property;
        }

        const langSel = this.selectedLanguage;
        const literals = value.literals[langSel.name];

        if (!literals) {
            return property;
        }

        const directMatch = literals[property];
        if (directMatch) {
            return directMatch || property;
        }

        const partialMatch = literals.find(f => f.key.toLowerCase().match(property.toLowerCase()) != null);
        if (partialMatch) {
            return partialMatch.value || property;
        }

        return property;
    }

    public getStaticTraduccion(value: string): string {
        let translatedValue = value;

        if (this.textosTraduccion) {
            if (this.textosTraduccion[this.selectedLanguage.name] && this.textosTraduccion[this.selectedLanguage.name][value]) {
                translatedValue = this.textosTraduccion[this.selectedLanguage.name][value];
            } else if (this.textosTraduccion['ES'] && this.textosTraduccion['ES'][value]) {
                translatedValue = this.textosTraduccion['ES'][value];
            }
        }

        return translatedValue;
    }

    private resolveTranslationParams(text: string, params?: Record<string, any>): string {
        if (!text || !params || Object.keys(params).length === 0) {
            return text;
        }

        let result = text;
        const values = Object.values(params);
        let positionalIndex = 0;

        result = result.replace(/\{([^{}]*)\}/g, (_match, key) => {
            const trimmedKey = key?.trim();

            if (!trimmedKey) {
                if (positionalIndex >= values.length) {
                    return _match;
                }

                const value = values[positionalIndex++];
                return value != null ? String(value) : '';
            }

            if (!(trimmedKey in params)) {
                return _match;
            }

            const value = params[trimmedKey];
            return value != null ? String(value) : '';
        });

        return result;
    }

	showSuccessToast(msg:string, delay:number=5000) {
		this.show(msg, { classname: 'bg-success text-light', delay: delay });
	}

	showDangerToast(msg:string, delay:number=5000) {
        this.show(msg, { classname: 'bg-danger text-light', delay: delay });
	}

    show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
        let toast = { textOrTpl, ...options };
		this.toasts.push(toast);
        setTimeout(()=>{
            this.remove(toast);
        }, toast.delay || 5000);
	}

	remove(toast) {
		this.toasts = this.toasts.filter((t) => t !== toast);
	}

	clear() {
		this.toasts.splice(0, this.toasts.length);
	}

    public TIMEZONE_OFFSET(){
        let now = moment.tz("Europe/Madrid");
        //console.log('now.utcOffset',now.utcOffset()/60)
        let offset = now.utcOffset()/60;
        if(offset >= 0) return "+"+offset;
        else return "-"+offset;
    }

    public setMeta(title:string, description:string){
        this.titleService.setTitle(title);
        this.meta.updateTag({ name: 'description', content: description });

        this.meta.updateTag({ property: 'og:title', content: title });
        this.meta.updateTag({ property: 'og:type', content: 'website' });
        this.meta.updateTag({ property: 'og:description', content: description });
    }
    

}


